import UserApplicationLayout from '@/layouts/UserApplicationLayout'

export default {
  path: '/station_activities',
  component: UserApplicationLayout,
  redirect: '/station_activities/list',
  children: [
    {
      path: 'list',
      component: () => import('@/views/station_activities/List'),
      meta: {
        // keepAlive: true
        // auth: Auth.listStationActivities
      }
    }
  ]
}
